import { trackViewPage } from './common'

export const trackViewMetadata = () => {
  trackViewPage({
    gaEventName: 'metadata',
    pageTitle: 'Metadata',
  })
}
